import { useNotificationsQuery } from 'graphql/types';
import { useApolloError } from 'common/hooks/useApolloError';

const PAGE_SIZE = 50;

export const useNotificationsList = () => {
    const { showApolloError } = useApolloError();

    const { data, loading, fetchMore } = useNotificationsQuery({
        variables: { first: PAGE_SIZE },
        notifyOnNetworkStatusChange: true,
        onError: showApolloError,
    });

    const { edges, pageInfo } = data?.notifications || {};
    const { hasNextPage, endCursor } = pageInfo || {};

    const fetchMoreResults = () => {
        if (!hasNextPage) return;

        fetchMore({
            variables: { first: PAGE_SIZE, after: endCursor },
        });
    };

    const notifications =
        edges?.map((edge) => edge?.node).filter(Boolean) || [];

    return { notifications, loading, hasNextPage, fetchMoreResults };
};
